import React from 'react';
import { 
  Settings, DollarSign, Shield, Server, Tag, 
  Megaphone, Flag, UserCog, Book, Bot
} from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import HelpArticlesManagement from './HelpArticlesManagement';
import {
  TierManagement,
  ContentModerationTab,
  RoleManagementTab,
  FinancialTab,
  SystemSettingsTab,
  SecurityTab,
  CategoriesTab,
  BroadcastTab,
  ModerationTab
} from './settings';

const AdminSettings = () => {
  return (
    <div className="min-h-screen bg-black text-white p-4 md:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <Settings className="w-8 h-8 text-yellow-400" />
          <h1 className="text-3xl font-bold">Admin Settings</h1>
        </div>

        <Tabs defaultValue="tiers" className="space-y-6">
          <TabsList className="grid grid-cols-5 md:grid-cols-10 bg-gray-800/50 mb-6">
            <TabsTrigger value="tiers" className="data-[state=active]:bg-yellow-500 data-[state=active]:text-black">
              <DollarSign className="w-4 h-4 mr-1" />
              <span className="hidden md:inline">Tiers</span>
            </TabsTrigger>
            <TabsTrigger value="ai-moderation" className="data-[state=active]:bg-yellow-500 data-[state=active]:text-black">
              <Bot className="w-4 h-4 mr-1" />
              <span className="hidden md:inline">AI Mod</span>
            </TabsTrigger>
            <TabsTrigger value="content-review" className="data-[state=active]:bg-yellow-500 data-[state=active]:text-black">
              <Flag className="w-4 h-4 mr-1" />
              <span className="hidden md:inline">Review</span>
            </TabsTrigger>
            <TabsTrigger value="roles" className="data-[state=active]:bg-yellow-500 data-[state=active]:text-black">
              <UserCog className="w-4 h-4 mr-1" />
              <span className="hidden md:inline">Roles</span>
            </TabsTrigger>
            <TabsTrigger value="financial" className="data-[state=active]:bg-yellow-500 data-[state=active]:text-black">
              <DollarSign className="w-4 h-4 mr-1" />
              <span className="hidden md:inline">Financial</span>
            </TabsTrigger>
            <TabsTrigger value="system" className="data-[state=active]:bg-yellow-500 data-[state=active]:text-black">
              <Server className="w-4 h-4 mr-1" />
              <span className="hidden md:inline">System</span>
            </TabsTrigger>
            <TabsTrigger value="security" className="data-[state=active]:bg-yellow-500 data-[state=active]:text-black">
              <Shield className="w-4 h-4 mr-1" />
              <span className="hidden md:inline">Security</span>
            </TabsTrigger>
            <TabsTrigger value="categories" className="data-[state=active]:bg-yellow-500 data-[state=active]:text-black">
              <Tag className="w-4 h-4 mr-1" />
              <span className="hidden md:inline">Categories</span>
            </TabsTrigger>
            <TabsTrigger value="broadcast" className="data-[state=active]:bg-yellow-500 data-[state=active]:text-black">
              <Megaphone className="w-4 h-4 mr-1" />
              <span className="hidden md:inline">Broadcast</span>
            </TabsTrigger>
            <TabsTrigger value="help" className="data-[state=active]:bg-yellow-500 data-[state=active]:text-black">
              <Book className="w-4 h-4 mr-1" />
              <span className="hidden md:inline">Help</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="tiers">
            <TierManagement />
          </TabsContent>

          <TabsContent value="ai-moderation">
            <ModerationTab />
          </TabsContent>

          <TabsContent value="content-review">
            <ContentModerationTab />
          </TabsContent>

          <TabsContent value="roles">
            <RoleManagementTab />
          </TabsContent>

          <TabsContent value="financial">
            <FinancialTab />
          </TabsContent>

          <TabsContent value="system">
            <SystemSettingsTab />
          </TabsContent>

          <TabsContent value="security">
            <SecurityTab />
          </TabsContent>

          <TabsContent value="categories">
            <CategoriesTab />
          </TabsContent>

          <TabsContent value="broadcast">
            <BroadcastTab />
          </TabsContent>

          <TabsContent value="help">
            <HelpArticlesManagement />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default AdminSettings;
